module.exports = __webpack_public_path__ + "img/school_building.be5030ca.webp";